import { render, staticRenderFns } from "./recycleBin.vue?vue&type=template&id=f2044fd2&"
import script from "./recycleBin.vue?vue&type=script&lang=js&"
export * from "./recycleBin.vue?vue&type=script&lang=js&"
import style0 from "./recycleBin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports